import { render, staticRenderFns } from "./TeamSeniorFunders.vue?vue&type=template&id=4984eb8b&scoped=true&"
import script from "./TeamSeniorFunders.vue?vue&type=script&lang=js&"
export * from "./TeamSeniorFunders.vue?vue&type=script&lang=js&"
import style0 from "./TeamSeniorFunders.vue?vue&type=style&index=0&id=4984eb8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4984eb8b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VDivider,VIcon,VProgressLinear,VRow,VSpacer,VTooltip})
